import React, { Component } from "react";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import { Button } from "reactstrap";
import ApiEndpoints from "../../../constants/api_endpoints";
import InputFeild from "../../global/form/input";
import "../../../styles/button.css";
import { Icon, Switch } from "@material-ui/core";
import store from "../../../store";
import { setError, setSuccess, setLoader } from "../../../actions/action-creators";
import { Input, FormGroup } from "reactstrap";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import LeadsDensityMap from "../../global/density_map";
import SelectList from "../../global/form/select";

class LeadsReportMapView extends Component {
  constructor(props) {
    super(props);
    this.state = {
        leadData: [],
        selectedCategory: [],
        selectedJobs: [],
        verificationStatus: null,
        startDate: moment().startOf("month").toDate(),
        endDate: null
    };
  }

  async componentDidMount() {
    await this.fetchLeadCountsByCity();
  }

  fetchLeadCountsByCity = async () => {
    store.dispatch(setLoader(true));
    let { selectedJobs, startDate, endDate, verificationStatus } = this.state;
    await this.setState({ leadData: [] })
    try {
        let body = {};
        if(startDate) body.start_date = startDate;
        if(endDate) body.end_date = endDate;
        if(verificationStatus >= 0) body.status = verificationStatus;
        if(selectedJobs.length) body.job_id = selectedJobs;

        let resp = await ApiEndpoints.Report.fetchLeadCountByCity(body);
        let leadData = resp.data.data;
        leadData = leadData.map(obj => {
            obj.lng = obj.long;
            return obj;
        })
        this.setState({ leadData })
    } catch (e) {
      store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
    }

    store.dispatch(setLoader(false));
  };

  selectJobCategory = (jobCategoryIds) => {
    let { jobList } = this.props;
    let jobIds = [];

    if(jobCategoryIds.length){
        jobIds = jobList.filter(o => jobCategoryIds.includes(o.job_category_id)).map(o => o.job_id);
    }

    this.setState({ selectedCategory: jobCategoryIds, selectedJobs: jobIds })
  }

  downloadData = () => {
    let { leadData } = this.state;
    let data = [["City", "State", "Lead Counts"]];
    leadData.forEach(obj => {
        data.push([obj.city || "", obj.state || "", obj.count || 0]);
    });
    data = data.map(row => row.join(",")).join("\n");
    const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'product_data.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  }

  render() {
    let { leadData, selectedCategory, selectedJobs, startDate, endDate, verificationStatus } = this.state;
    let { jobCategoryList, jobList } = this.props;

    return (
        <div>
            <Row>
                <Col>
                    <SelectList selectAll="All Category" multiple="checkbox" placeholder="Filter Category" value={selectedCategory || []}  onChange={(e) => this.selectJobCategory(e.target.value) } >
                        {jobCategoryList.map(cat => 
                            <option key={cat.job_category_id} value={cat.job_category_id}>{cat.title}</option>
                        )}
                    </SelectList>
                </Col>
                <Col>
                    <SelectList placeholder="Select Project" search={true} multiple="checkbox" value={selectedJobs || []} onChange ={(e) => { this.setState({selectedJobs: e.target.value})}} >
                    {jobList.map(job => 
                        <option key={job.job_id} value={job.job_id}>{job.Employer.employer_name +  "-"  + job.title}</option>
                    )}
                    </SelectList>
                </Col>
                <Col>
                    <SelectList placeholder="Lead Status" value={verificationStatus} onChange ={(e) => { this.setState({verificationStatus: e.target.value})}} >
                        <option value={0}>Pending</option>
                        <option value={1}>Verified</option>
                        <option value={2}>Rejected</option>
                    </SelectList>
                </Col>
                <Col className="mb-2">
                    <ReactDatePicker
                        selected={startDate || null}
                        onChange={date => this.setState({startDate: date}) }
                        isClearable={true}
                        autoComplete={false}
                        dateFormat='dd-MMM-yyyy'
                        placeholderText="Start Date"
                    />
                </Col>
                <Col className="mb-2 pr-4">
                    <ReactDatePicker
                        selected={endDate || null}
                        onChange={date => this.setState({endDate: date}) }
                        isClearable={true}
                        autoComplete={false}
                        dateFormat='dd-MMM-yyyy'
                        placeholderText="End Date"
                    />
                </Col>
            </Row>
            <Row>
                <Col className="text-right">
                    <Button className="mr-3" color="dark" size="sm" onClick={() => this.fetchLeadCountsByCity()}>Apply Filter</Button>
                </Col>
            </Row>
            <Icon className="clickable" onClick={() => this.downloadData()}>download</Icon>
            <Row noGutters className="p-2">
                <Col xs={3} className="pr-2">
                    <div style={{maxHeight: "100vh", overflowY: "scroll"}}>
                    {leadData.map(row => {
                        return (
                        <div className="my-1 px-2 py-1 shadow-sm border" style={{borderRadius: 8}}>
                            <Row noGutters className="align-items-center" >
                                <Col>
                                    <span className="small font-weight-bold">{row.city}</span>
                                    <span className="d-block small">{row.state}</span>
                                </Col>
                                <Col xs={"auto"}>{row.count}</Col>
                            </Row>
                        </div>
                        )
                    })}
                    </div>
                </Col>
                <Col xs={9}>
                    {!!leadData.length && <LeadsDensityMap leads={leadData}/>}
                </Col>
            </Row>
        </div>
    );
  }
}

export default LeadsReportMapView;
